import { render, staticRenderFns } from "./HarvestsDataTable.vue?vue&type=template&id=1abadc2a&scoped=true"
import script from "./HarvestsDataTable.vue?vue&type=script&lang=ts"
export * from "./HarvestsDataTable.vue?vue&type=script&lang=ts"
import style0 from "./HarvestsDataTable.vue?vue&type=style&index=0&id=1abadc2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abadc2a",
  null
  
)

export default component.exports